import { render, staticRenderFns } from "./TeamMemberForm.vue?vue&type=template&id=98444558&scoped=true&"
import script from "./TeamMemberForm.vue?vue&type=script&lang=js&"
export * from "./TeamMemberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98444558",
  null
  
)

export default component.exports